const AceOcnPermitToTransferApiUrls = {
    GET: `${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/permittotransfer/get`,
    POST: `${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/permittotransfer/create`,
    PUT: `${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/permittotransfer/update`,
    DELETE: `${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/permittotransfer/delete`,
    EXPORT: `${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/permittotransfer/download`,
    SUBMIT: `${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/permittotransfer/submit`,
    GETRESPONSE: `${process.env.REACT_APP_USER_ACE_OCEAN_URL}/ace-ocean/permittotransfer-response/get`
  };
  
  export default AceOcnPermitToTransferApiUrls
  